import axios from 'axios'

export default {
  namespaced: true,
  state: {
    access_token: localStorage.getItem('access_token'),
    user: null,
    userPermissions: [], // Dynamically Changed By Landing
    impersonating: false
  },
  mutations: {
    loginSuccess(state, data) {
      state.access_token = data.access_token
      localStorage.setItem('access_token', data.access_token)
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + data.access_token
    },
    getProfileSuccess(state, user) { state.user = user },
    updateProfileSuccess(state, user) { state.user = user },
    logout(state) {
      state.impersonating = false
      state.user = null
      state.access_token = null
      delete axios.defaults.headers.common['Authorization']
      localStorage.removeItem('access_token')
      localStorage.removeItem('main_access_token')
      localStorage.removeItem('main_access_role')
      this.dispatch('paymentMethod/resetAll')
    },
    impersonateSuccess(state, data) {
      if (!localStorage.getItem('main_access_token')) {
        localStorage.setItem('main_access_token', state.access_token)
        localStorage.setItem('main_access_role', state.user && state.user.role || undefined)
      }
      this.dispatch('paymentMethod/resetAll')
      state.impersonating = true
      state.user = null
      localStorage.setItem('access_token', data.access_token)
      state.access_token = data.access_token
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + data.access_token
    },
    registerFreeSuccess(state, { user, res: data }) {
      state.access_token = data.access_token
      localStorage.setItem('access_token', data.access_token)
      axios.defaults.headers.common['Authorization'] =  'Bearer ' + data.access_token
    },
    registerAgencySuccess(state, { user, res: data }) {
      try {
        if (typeof window.$FPROM !== 'undefined') {
          window.$FPROM.trackSignup({ email: user.email, uid: data.uid }, () => {})
        }
      } catch(t) {}
      state.access_token = data.access_token
      localStorage.setItem('access_token', data.access_token)
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + data.access_token
    },
    stopImpersonateSuccess(state, data) {
      localStorage.setItem('access_token', localStorage.getItem('main_access_token'))
      state.access_token = localStorage.getItem('main_access_token')
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('main_access_token')

      localStorage.removeItem('main_access_token')
      localStorage.removeItem('main_access_role')

      this.dispatch('paymentMethod/resetAll')
      this.dispatch('subscription/resetAll')

      state.impersonating = false
      state.user = null
    },
    SET_USER_PERMISSIONS(state, userPermissions) {
      state.userPermissions = userPermissions
    },
    loading(state, loading) { this.state.app.loading = loading }
  },
  actions: {
    login({ commit }, credentials) {
      return new Promise((resolve, reject) => {
        axios
          .post('/login', credentials)
          .then((res) => {
            commit('loginSuccess', res.data)
            resolve(true)
          })
          .catch((error) => reject(error))
      })
    },
    forgotPassword({ commit }, credentials) {
      return new Promise((resolve, reject) => {
        axios
          .post('/passwords/reset', credentials)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    changePassword({ commit }, credentials) {
      return new Promise((resolve, reject) => {
        axios
          .post('/passwords/change', credentials)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    changeUserPassword({ commit }, params) {
      return new Promise((resolve, reject) => {
        const apiPath = params.user_id ? `/users/${params.user_id}/change-password` : '/change-password'
        axios
          .post(apiPath, params)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    logout({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .post('/logout')
          .then(() => {
            commit('logout')
            resolve(true)
          })
          .catch((error) => reject(error))
      })
    },
    getProfile({ commit }, showLoading = false) {
      if (showLoading) commit('loading', true)
      return new Promise((resolve, reject) => {
        axios
          .get('/profile')
          .then((res) => {
            if (showLoading) commit('loading', false)
            commit('getProfileSuccess', res.data.data)
            resolve(res.data.data)
          })
          .catch((error) => {
            if (showLoading) commit('loading', false)
            commit('logout')
            reject(error)
          })
      })
    },
    updateProfile({ commit }, user) {
      return new Promise((resolve, reject) => {
        axios
          .put('/profile', user)
          .then((res) => {
            commit('updateProfileSuccess', res.data.data)
            resolve(true)
          })
          .catch((error) => {
            if (error.response.status === 401) commit('logout')
            reject(error)
          })
      })
    },
    impersonate({ commit }, userId) {
      commit('loading', true)
      return new Promise((resolve, reject) => {
        axios
          .post(`/impersonate/${userId}`)
          .then((response) => {
            commit('loading', false)
            commit('impersonateSuccess', response.data)
            resolve(true)
          })
          .catch((e) => {
            commit('loading', false)
            reject(e)
          })
      })
    },
    stopImpersonate({ commit }) {
      commit('loading', true)
      return new Promise((resolve, reject) => {
        axios
          .delete(`/impersonate`)
          .then((res) => {
            commit('loading', false)
            commit('stopImpersonateSuccess', res.data)
            resolve(true)
          })
          .catch((e) => {
            commit('loading', false)
            reject(e)
          })
      })
    },
    checkValidity({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .post('/check-validity', params)
          .then((response) => {
            if (response && response.data && response.data.access_token) {
              const user = { email: params.email }
              const res = { uid: params.uid, access_token: response.data.access_token }
              commit('registerAgencySuccess', { user, res })
            }
            resolve(response.data)
          })
          .catch((error) => reject(error))
      })
    },
    checkEmail({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .post('/check-email', params)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    registerFree({ commit }, user) {
      return new Promise((resolve, reject) => {
        axios
          .post('/register', user)
          .then((res) => {
            commit('registerFreeSuccess', { user, res: res.data })
            resolve(true)
          })
          .catch((error) => reject(error))
      })
    },
    registerAgency({ commit }, user) {
      return new Promise((resolve, reject) => {
        axios
          .post('/order', user)
          .then((res) => {
            commit('registerAgencySuccess', { user, res: res.data })
            resolve(true)
          })
          .catch((error) => reject(error))
      })
    },
    purchaseCourse({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .post('/order-onetime', params)
          .then((res) => resolve(res.data))
          .catch((error) => reject(error))
      })
    },
    setUserPermissions({ commit }, userPermissions) {
      commit('SET_USER_PERMISSIONS', userPermissions)
    }
  },
  getters: {
    isLoggedIn: (state) => !!state.access_token,
    isImpersonating(state) { return state.impersonating },
    user: (state) => state.user,
    userPermissions(state) { return state.userPermissions },
    isValidUser(state) {
      if (!state.user || !state.user.agency || !state.user.agency.id) return false
      if (
        !state.user.agency.subscribed &&
        !state.user.agency.free_fee &&
        !state.user.agency.free_register
      ) {
        return false
      }
      return true
    },
    blockedScreen(state) {
      if (
        state.user &&
        state.user.role === 'Agency' &&
        state.user.agency &&
        !state.user.agency.subscribed && !state.user.agency.free_fee && !state.user.agency.free_register &&
        (!state.user.hasCourses || (state.user.agency.stripe_status !== 'canceled' && state.user.agency.reseller_status !== 'canceled'))
      ) {
        return true
      }
      return false
    }
  }
}